import getSweepRules from 'owa-sweep-rules-option/lib/actions/getSweepRules';
import { loadFoldersFromSessionData } from 'owa-folders';
import SweepRulesOption from 'owa-sweep-rules-option/lib/SweepRulesOption';
var sweepSubCategory = {
    key: 'sweep',
    titleStringKey: 'optionSubcategory_sweep',
    options: [SweepRulesOption],
    onSelected: function () {
        loadFoldersFromSessionData();
        // VSTS 24214: Keep old sweep rules on the screen while waiting for the reload
        return getSweepRules();
    },
};
export default sweepSubCategory;
//# sourceMappingURL=sweepSubCategory.js.map